import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=08208aa7&scoped=true&"
import script from "./Forms.vue?vue&type=script&lang=ts&"
export * from "./Forms.vue?vue&type=script&lang=ts&"
import style0 from "./Forms.less?vue&type=style&index=0&id=08208aa7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08208aa7",
  null
  
)

export default component.exports